import { NetworkStatus } from '@cbridge-utils/network';
import { ISymbolLpStore } from './symbolLp.interface';

export const symbolLpInitialState: ISymbolLpStore = {
  data: {},
  unmappedSymbols: {
    list: [],
    networkStatus: NetworkStatus.None,
  },
  counters: {},
  networkStatus: NetworkStatus.None,
};
